import { APP_KIND } from "@config";
import { v2RequestBlob } from "../api/v2Client";

const urls = new Map();
const inflight = new Map();

function photoPath(clubId, playerId) {
  return `/${APP_KIND}/clubs/${clubId}/players/${playerId}/photo`;
}

export function peekPlayerPhoto(playerId) {
  if (!playerId) return null;
  return urls.has(playerId) ? urls.get(playerId) : undefined;
}

export async function loadPlayerPhoto(clubId, playerId, { signal } = {}) {
  if (!clubId || !playerId) return null;
  if (urls.has(playerId)) return urls.get(playerId);
  if (inflight.has(playerId)) return inflight.get(playerId);

  const request = (async () => {
    try {
      const blob = await v2RequestBlob(photoPath(clubId, playerId), { signal });
      if (!blob || blob.size === 0) {
        urls.set(playerId, null);
        return null;
      }
      const url = URL.createObjectURL(blob);
      urls.set(playerId, url);
      return url;
    } catch (error) {
      if (error?.status === 404) {
        urls.set(playerId, null);
        return null;
      }
      throw error;
    }
  })();

  inflight.set(playerId, request);
  try {
    return await request;
  } finally {
    inflight.delete(playerId);
  }
}
